import React from 'react';
import {FormattedMessage} from "react-intl";
import {connect} from "react-redux";

import {
  cancelVisualizerManagementChanges,
  getPresetsName,
  saveVisualizerManagement
} from "./VisualizerManagementActions";
import {VISUALIZER_TYPES} from "../../constants/dashboard";
import {VISUALIZER_MANAGEMENT_ACTIONS} from "./VisualizerManagement";


const VisualizerManagementFooter = (props) => {

  const {cancelVisualizerManagementChanges, saveVisualizerManagement, activeTab} = props;

  const handleSavePresets = () => {
    const forTool = VISUALIZER_TYPES[activeTab] || VISUALIZER_TYPES.bathroom;
    const iframeElement = document.getElementById("visualizerIframe");
    if (!iframeElement) {
      alert("No iframe found!");
      return;
    }
    iframeElement.contentWindow.postMessage({ // close everything inside the visualizer
      action: VISUALIZER_MANAGEMENT_ACTIONS.closeVisualizerNavigation
    }, iframeElement.src);
    iframeElement.contentWindow.postMessage({ // post message to prepare all info and pass it back to the visualizerManagement.js
      action: VISUALIZER_MANAGEMENT_ACTIONS.getState
    }, iframeElement.src);
  };

  const handleFooterSaveClick = () => {
    if (activeTab === "mobile_links") {
      saveVisualizerManagement();
      return
    }
    handleSavePresets();
  }

  const saveDisabled = false;

  return (
    <div className="app-content-footer app-content-footer--fixed">
      <div className="app-content-footer__buttons">
        <button className="ui-button ui-button--blue" onClick={cancelVisualizerManagementChanges}>
          <span className="ui-button-text ui-button--uppercase">
            <FormattedMessage id="messageBox.buttons.cancel"/>
          </span>
        </button>
        <button className={"ui-button ui-button--green ui-button--large" + (saveDisabled ? " ui-button--disabled" : "")}
                disabled={saveDisabled}
                onClick={handleFooterSaveClick}>
          <span className="ui-button-text ui-button--uppercase">
            <FormattedMessage id="messageBox.buttons.save"/>
          </span>
        </button>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {activeTab} = store.visualizerManagement;
  return {
    activeTab,
  };
};

const mapDispatchToProps = {
  cancelVisualizerManagementChanges,
  saveVisualizerManagement,
};

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerManagementFooter);
